import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { ButtonModule } from 'primeng/button';

import { CorporateReportingStoreService } from '../../../services/stores/corporate-reporting-store.service';
import { PerformanceHotelRow } from '../../../domain/corporate/performance-hotel-row';
import { TopPerformingHotelsTableComponent } from '../top-performing-hotels-table/top-performing-hotels-table.component';
import { UnderPerformingHotelsTableComponent } from '../under-performing-hotels-table/under-performing-hotels-table.component';
import { StaffPerformanceRowVm } from '../../../domain/corporate/staff-performance-row-vm';
@Component({
   selector: 'app-performance-hotels-panel',
   standalone: true,
   imports: [
      CommonModule,
      ButtonModule,
      TopPerformingHotelsTableComponent,
      UnderPerformingHotelsTableComponent
   ],
   templateUrl: './performance-hotels-panel.component.html',
   styleUrls: ['./performance-hotels-panel.component.scss']
})
export class PerformanceHotelsPanelComponent {
   topRows$!: Observable<PerformanceHotelRow[]>;
   underRows$!: Observable<PerformanceHotelRow[]>;
   loading$!: Observable<boolean>;
   errorStatus$!: Observable<number | null>;
   staffByPropertyId$!: Observable<Map<number, StaffPerformanceRowVm[]>>;

   constructor(private store: CorporateReportingStoreService) {
      this.topRows$ = this.store.topPerformingHotels$;
      this.underRows$ = this.store.underPerformingHotels$;
      this.loading$ = this.store.performanceLoading$;
      this.errorStatus$ = this.store.performanceErrorStatus$;
      this.staffByPropertyId$ = this.store.staffPerformanceByPropertyId$;
   }
}
